(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["haunt-design"] && !Shopify.designMode) return;
  try {
    (()=>{function init(scope=document){scope.querySelectorAll('.hl-hero:not([data-ready])').forEach(root=>{root.dataset.ready='true';const btn=root.querySelector('[data-hl-motion]');const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;let paused=reduced;const sync=()=>{root.classList.toggle('hl-paused',paused);btn.textContent=paused?'Play atmosphere':'Pause atmosphere';btn.setAttribute('aria-pressed',String(paused));const video=root.querySelector('video');if(video){if(paused)video.pause();else video.play().catch(()=>{});}};btn.addEventListener('click',()=>{paused=!paused;sync();});root.addEventListener('pointermove',e=>{if(paused||reduced||e.pointerType==='touch')return;let r=root.getBoundingClientRect();root.style.setProperty('--hx',((e.clientX-r.left)/r.width-.5)*-10+'px');root.style.setProperty('--hy',((e.clientY-r.top)/r.height-.5)*-7+'px');});sync();});scope.querySelectorAll('[data-hl-reveal]:not([data-ready])').forEach(input=>{input.dataset.ready='true';input.addEventListener('input',()=>{input.closest('.hl-look-wrap').querySelector('.hl-look').style.setProperty('--reveal',input.value+'%');});});scope.querySelectorAll('[data-hl-filter]:not([data-ready])').forEach(root=>{root.dataset.ready='true';const search=root.querySelector('input');const select=root.querySelector('select');const cards=[...root.querySelectorAll('[data-title]')];function filter(){cards.forEach(c=>{c.hidden=!c.dataset.title.includes(search.value.toLowerCase())||(select.value!=='all'&&c.dataset.category!==select.value);});root.querySelector('[data-count]').textContent=cards.filter(c=>!c.hidden).length+' planned items';}search.addEventListener('input',filter);select.addEventListener('change',filter);filter();});scope.querySelectorAll('[data-hl-gallery]:not([data-ready])').forEach(root=>{root.dataset.ready='true';root.querySelectorAll('[data-scene]').forEach(btn=>btn.addEventListener('click',()=>{root.querySelector('[data-main-scene]').className='hl-scene s'+btn.dataset.scene;root.querySelectorAll('[data-scene]').forEach(b=>b.setAttribute('aria-pressed',String(b===btn)));}));});}init();document.addEventListener('shopify:section:load',e=>init(e.target));})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["haunt-market-default"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('haunt-market-default')) {
  customElements.define('haunt-market-default', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const preferenceKey = 'hauntlora-country-choice';
      const attemptKey = 'hauntlora-us-market-attempt';
      const rememberChoice = () => {
        try { sessionStorage.setItem(preferenceKey, 'chosen'); } catch (_) {}
      };
      document.addEventListener('click', (event) => {
        const choice = event.target.closest('[data-value]');
        if (choice && choice.closest('form')?.querySelector('[name="country_code"]')) rememberChoice();
      }, true);
      document.addEventListener('submit', (event) => {
        if (event.target.querySelector('[name="country_code"]')) rememberChoice();
      }, true);
      const form = this.querySelector('form');
      if (!form) return;
      const destination = form.querySelector('[name="return_to"]');
      if (destination) destination.value = window.location.pathname + window.location.search + window.location.hash;
      if (this.dataset.country !== 'PK' || this.dataset.designMode === 'true') return;
      try {
        if (sessionStorage.getItem(preferenceKey) || sessionStorage.getItem(attemptKey)) return;
        sessionStorage.setItem(attemptKey, '1');
      } catch (_) { return; }
      HTMLFormElement.prototype.submit.call(form);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
